/**
 * PostHog experiment flag keys for ai-consumer. Delete each constant (and its
 * call site) once the experiment concludes and a variant is picked as the
 * permanent behavior — see [[project_ai_consumer_perf]] memory for the last
 * time this app's posthog wiring was fully removed.
 */

/**
 * Post-signup routing test. Right after account creation on the personal-info
 * page, `test` sends the lead straight to plan-finder-z1's MA marketplace
 * instead of continuing into the ai-consumer quiz (situation/doctors/drugs/
 * etc.); `control` keeps the current in-app flow. 50/50 split.
 */
export const EXP_POST_SIGNUP_Z1_REDIRECT = 'ai-consumer-post-signup-z1-redirect';
